/** Which of a stage's two frontends is meant — the classic UI or the migrated one. */
export type DeploymentVariant = 'classic' | 'next';

/** User-facing name per variant. */
export const VARIANT_LABELS: Record<DeploymentVariant, string> = {
  classic: 'Classic',
  next: 'Next',
};

/**
 * Which frontend this branch builds. Baked in per branch — `next` here, `classic` on `dev` —
 * because a dev machine serves both branches from the same origin, so the hostname can't say.
 * This is display state only; gate deployment behaviour on the HOST, never on this.
 */
export const BUILD_VARIANT: DeploymentVariant = 'next';

/** The variant that isn't `variant`. */
export function otherVariant(variant: DeploymentVariant): DeploymentVariant {
  return variant === 'next' ? 'classic' : 'next';
}
